export default "__VITE_ASSET__ee0fe112__"